import { CatalogPumpCapacitiesResponse } from '@cemex-core/cmx-api';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';
import {
  BusinessLinesActions,
  LOAD,
  LOAD_COMPLETE,
  LOAD_INITIAL_STATE,
  LOAD_REPEAT,
  RESET,
  SET,
  SET_DIRECT,
} from '../../actions/business-line.actions';

export interface BusinessLinesState {
  loaded: boolean;
  loading: boolean;
  businessLines: ProductType[];
  selected: ProductType;
  capacities: CatalogPumpCapacitiesResponse;
}

export const initialState: BusinessLinesState = {
  loaded: false,
  loading: false,
  businessLines: [],
  selected: null,
  capacities: null,
};

export function businessLineReducer(state = initialState, action: BusinessLinesActions): BusinessLinesState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      return initialState as BusinessLinesState;
    }
    case LOAD: {
      return {
        ...state,
        loading: true,
      } as BusinessLinesState;
    }
    case LOAD_COMPLETE: {
      const businessLines: ProductType[] = action.payload.productTypes;
      return {
        loaded: true,
        loading: false,
        businessLines: businessLines,
        selected: null,
      } as BusinessLinesState;
    }
    case SET: {
      const selectedBusinessLine: ProductType = state.businessLines.find(
        (bl: ProductType) => bl.productTypeId === action.payload.productTypeId,
      );
      return {
        ...state,
        selected: selectedBusinessLine,
      } as BusinessLinesState;
    }
    case SET_DIRECT: {
      return {
        ...state,
        selected: action.payload,
      } as BusinessLinesState;
    }
    case RESET: {
      return initialState;
    }
    case LOAD_REPEAT: {
      const businessLines: ProductType[] = action.payload.productTypes;
      return {
        loaded: true,
        loading: false,
        businessLines: businessLines,
        selected: businessLines[0],
      } as BusinessLinesState;
    }
    default: {
      return state;
    }
  }
}
